// extracted by css-extract-rspack-plugin
export default {"List":"List-module__List__j9yVV"};